import { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { BrandFormV2 } from "./components/BrandFormV2";
import { Brand, CreateBrandRequest } from "../../types/BrandModels";
import { fetchBrands } from "../../services/brandService";
import { debug } from "../../utils/debugLogger";

const BrandManager = ({ customerId }: { customerId: string }) => {
  const { idToken } = useAuth();
  const navigate = useNavigate();

  const handleBrandComplete = () => {
    // Optionally refresh or show success message
    debug.log("✅ Brand saved successfully from BrandManager");
  };

  // Simply render the BrandFormV2 directly
  return (
    <div className="rounded-xl border border-zinc-200/90 bg-white p-6 shadow-sm ring-1 ring-zinc-200/60">
      <BrandFormV2 customer_id={customerId} onComplete={handleBrandComplete} />
    </div>
  );
};

export default BrandManager;
